<template>
    <div  class="topbar" :data-time = "start.datetime ? (hasTriggeredStart ? end.datetime : start.datetime) : end.datetime">
      <p  class="promo-text">
        {{ start.text ? (hasTriggeredStart ? end.text : start.text) : end.text }}
      </p>
      <div class="countdown" v-if="!end?.is_show" >
        <span>{{ convertNumber(days) ?? "00" }} <small class="text_date">DAYS</small></span> :
        <span>{{ convertNumber(hours) ?? "00" }} <small class="text_date">HOURS</small></span> :
        <span>{{ convertNumber(minutes) ?? "00" }} <small class="text_date">MINUTES</small></span>
        <span style="display: none;" >{{ convertNumber(seconds)??"00" }} <small>Secs</small></span>
      </div>
      <div class="countdown-bar__cta-action" v-if="!props.check_cny">
        <a
          v-if="(start?.button?.url || end?.button?.url) && (start || end)"
          :href="start?.button?.url || end?.button?.url"
          class="countdown-bar__cta-button"
        >
          {{ start?.button?.title || end?.button?.title }}
          <img style="margin-left: 5px;" class="btn_arr" src="@/assets/images/arr_right_red.svg" width="15" height="15"
          alt="" />
        </a>
        <a
          v-else
          class="countdown-bar__cta-button"
          >Shop Now<img style="margin-left: 5px;" class="btn_arr"
          src="@/assets/images/arr_right_red.svg" width="15" height="15" alt="" /></a
        >
      </div>
      <div class="countdown-bar__cta-action" v-else >
        <a  @click.prevent="loadingAtcCny"
          v-if="(start?.button?.url || end?.button?.url) && (start || end)"
          href="/cny"
          class="countdown-bar__cta-button"
        >
          {{ start?.button?.title || end?.button?.title }}
          <img style="margin-left: 5px;" class="btn_arr" src="@/assets/images/arr_right_red.svg" width="15" height="15"
          alt="" />
        </a>
        <a  @click.prevent="loadingAtcCny" href="/cny"
          v-else
          class="countdown-bar__cta-button"
          >Shop Now<img style="margin-left: 5px;" class="btn_arr"
          src="@/assets/images/arr_right_red.svg" width="15" height="15" alt="" /></a
        >
      </div>
    </div>
  </template>

  <script setup>
  import { ref, computed, onMounted } from "vue";
  const { $ajax } = useNuxtApp();
  const isLoading = ref(true);
  const router = useRouter();
const route = useRoute();
  const convertNumber  = (num) => {
      if (num < 10) {
          return "0" + num;
      } else {
          return num
      }
  }
  const userStore = useUserStore();
  const props = defineProps({
      start: Object,
      end: Object,
      check_cny: Boolean,
  })
  const emit = defineEmits(["handleSetisExpired", "loading-cny"]);

  const startData = ref({

  });
  const btnLink = ref("");
  const endData = ref({

  });
  const activeData = ref();
  const isExpired = ref(true);
  const days = ref(0);
  const hours = ref(0);
  const minutes = ref(0);
  const seconds = ref(0);
  const loading_cny = ref(false);
onMounted(() => {
      updateCountdown();
      setInterval(updateCountdown, 1000);
  })

  const hasTriggeredStart = ref(false);
const hasTriggeredEnd = ref(false);

const updateCountdown = async () => {
  const now = new Date();
  const startTime = props.start?.datetime ? getDateFromTimeZone(props.start.datetime) : null;
  const endTime = props.end?.datetime ? getDateFromTimeZone(props.end.datetime) : null;
  if (startTime && now < startTime) {
    const distance = startTime - now;
    activeData.value = props.start;
    btnLink.value = props.start.button.url;
    setCountdown(distance);
    // hasTriggeredStart.value = false;
  }
  if (startTime && startTime < now) {
    if (!hasTriggeredStart.value) {
      actionsTopbar();
      hasTriggeredStart.value = true;
    }
  }
  if( startTime &&  startTime < now &&  now < endTime) {
    activeData.value = props.end;
    btnLink.value =  props.end.button.url;
    const distance = endTime - now;
    setCountdown(distance);
  }
  if( !startTime &&  now < endTime) {
    hasTriggeredStart.value = true;
    activeData.value = props.end;
    btnLink.value =  props.end.button.url;
    const distance = endTime - now;
    setCountdown(distance);
  }
   if ( now > endTime) {
    emit('handleSetisExpired', true);
    if (!hasTriggeredEnd.value) {
      actionsTopbar();
      hasTriggeredEnd.value = true;
    }


  }

// isLoading.value = false;
};
const loadingAtcCny = () => {
  loading_cny.value = true;
  emit('loading-cny', true);
  // Set cookie
  const pageElement = document.getElementById('page');
  if (pageElement) {
    pageElement.style.top = '0px';
  }
  
  let cnyUrl = '/cny';
   
   setTimeout(() => {
      router.push(cnyUrl);
   }, 800);
}

  const setCountdown = (distance) => {
    days.value = Math.floor(distance / (1000 * 60 * 60 * 24));
    hours.value = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
    );
    minutes.value = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    seconds.value = Math.floor((distance % (1000 * 60)) / 1000);
    // console.log(days.value,
    //   hours.value,
    //   minutes.value,
    //   seconds.value
    // )
  };

  // onMounted(() => {
  //   updateCountdown();
  //   setInterval(updateCountdown, 1000);
  // });
  const actionsTopbar = async () => {
  try {
    const url = `wp-admin/admin-ajax.php?action=alt_update_topbar&live=true`;
     await $ajax.get(url, {
      headers: {
        Authorization: `Bearer ${userStore.csrf}`,
      },
    });
  } catch (error) {
    console.error('actionsTopbarError:', error);
  }
};
// console.log('activeData.value', activeData.value);
  </script>

    <style lang="scss" scoped>
    @import "@/assets/scss/components/top-bar/_top-normal.scss";
  </style>
